import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { KIOSK_CATEGORY_PAGE_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import { DoodCategoryWithProduct } from '@shared/interfaces/category.interface';
import type { KioskCategoryPageScenarioContent } from '@front-platform/content-builder';

export type KioskCategoryPagePreviewViewModel = {
  categoryId: string;
  categoryWithProducts: DoodCategoryWithProduct | null;
  subCategoriesWithProducts: readonly DoodCategoryWithProduct[];
};

@Injectable()
export class KioskCategoryPagePreviewDataSource {
  readonly vm$: Observable<KioskCategoryPagePreviewViewModel | null> = previewScenarioForBloc$(
    KIOSK_CATEGORY_PAGE_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return null;
      }

      const content = previewScenarioData<KioskCategoryPageScenarioContent>(
        scenario,
        KIOSK_CATEGORY_PAGE_COMPONENT,
      );

      if (!content) {
        return null;
      }

      return {
        categoryId: content.categoryId,
        categoryWithProducts: content.categoryWithProducts as DoodCategoryWithProduct | null,
        subCategoriesWithProducts:
          content.subCategoriesWithProducts as unknown as readonly DoodCategoryWithProduct[],
      };
    }),
  );
}
